<template>
    <section v-if="json" class="page-work">
        <FilterSet/>
        <GridOuter v-if="json.workGrid" :json="json.workGrid" type="work" section="work" :paginate="20"></GridOuter>
    </section>
    <section v-else class="page-work">
        <Loading v-if="showLoading"/>
    </section>
</template>

<script>
import axios from 'axios'
import gh from '@/helpers/gh'
import GridOuter from "@/components/blocks/GridOuter"
import FilterSet from "@/components/blocks/FilterSet"
import Loading from "@/components/blocks/Loading"
import {mapState} from "vuex";

export default {
    name: "WorkPage",
    components: {
        GridOuter,
        FilterSet,
        Loading
    },
    data() {
        return {
            window: window,
            json: null,
            transition: false,
            loadingTimer: null,
            showLoading: false
        };
    },
    computed: {
        ...mapState({
            selectedFilters: state => state.selectedFilters,
        }),
    },
    mounted() {
        //let slug = this.$route.fullPath;
        let slug = 'work'
        slug = gh.stripSlashesFrontAndBack(slug);

        // start a timer to only show Loading after 1s
        this.loadingTimer = setTimeout(() => {
            this.showLoading = true
        },1000)

        axios.get((`${window.config.apiroot}${slug}/${window.config.craftApiPreviewToken}`))
        .then((res) => {
            this.json = res.data;
            this.reveal();
            this.showLoading = false
        })
        .catch((e) => {
            console.error("Error", slug, e);
            this.showLoading = false
        });
    },
    methods: {
        reveal() {
        },
        unreveal() {
        },
    },
};
</script>
